import type { IconSvgObject } from './types';

const RightAngleIcon: IconSvgObject = [
  ["path", { d: "M6 12H10C11.1046 12 12 12.8954 12 14V18", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 18.5H6.5C5.94772 18.5 5.5 18.0523 5.5 17.5V3M21 18.5L18.5 16M21 18.5L18.5 21M5.5 3L8 5.5M5.5 3L3 5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RightAngleIcon;
